import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '@env/environment';

export interface Dienstnehmer {
  id: number;
  name: string;
  dienstnummer: number;
  dienstnummer_stvo: number;
  active: number;
  benutzergruppe: number;
  sachbereich: string;
  kennwort?: string; // write-only
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class DienstnehmerService {
  errorMsg = '';

  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<Dienstnehmer[]> {
    return this.httpClient
      .get<any>(`${environment.serverUrl}/dienstnehmer`, httpOptions)
      .pipe(
        map((response) => (response?.data || []) as Dienstnehmer[]),
        catchError((error) => this.handleError(error))
      );
  }

  getById(id: number): Observable<Dienstnehmer> {
    return this.httpClient
      .get<any>(`${environment.serverUrl}/dienstnehmer/${id}`, httpOptions)
      .pipe(
        map((response) => response?.data as Dienstnehmer),
        catchError((error) => this.handleError(error))
      );
  }

  save(dn: Dienstnehmer): Observable<any> {
    const url =
      dn.id && dn.id > 0
        ? `${environment.serverUrl}/dienstnehmer/${dn.id}`
        : `${environment.serverUrl}/dienstnehmer`;

    return this.httpClient
      .post<any>(url, JSON.stringify(dn), httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }

  delete(id: number): Observable<any> {
    // route shape: /dienstnehmer/{id}/{quuid}/{pid}
    return this.httpClient
      .delete<any>(`${environment.serverUrl}/dienstnehmer/${id}/0/0`, httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      this.errorMsg = `Error: ${error.error.message}`;
    } else {
      this.errorMsg = `Server error: ${error.status}`;
    }
    return throwError(this.errorMsg);
  }
}
